<template>
    <section>
        <div class="row justify-content-center">
            <div class="col col-lg-10 px-5">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb mt-5 mb-0 py-0">
                        <li class="breadcrumb-item h3 font-weight-bold active mb-0 text-uppercase" aria-current="page">
                            Forum
                        </li>
                    </ul>
                    <ul class="breadcrumb forum py-0">
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'index' }">
                                Home
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/index' }">
                                Forum
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/subject', params: {id: thread.forumSubcategory.gradeSubject.gradeID} }">
                                {{ thread.forumSubcategory.gradeSubject.grade.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/category', params: {id: thread.forumSubcategory.gradeSubjectID} }">
                                {{ thread.forumSubcategory.gradeSubject.subject.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/thread/index', params: {id: thread.forumSubcategoryID} }">
                                {{ thread.forumSubcategory.title }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium active" aria-current="page">
                            {{ thread.title }}
                        </li>
                    </ul>
                </nav>
                <div class="row">
                    <div class="col">
                        <div class="card shadow-sm mb-3 border-0">
                            <div class="card-body">
                                <div class="row align-items-center">
                                    <div class="col-auto">
                                        <h4 class="font-weight-medium mb-0">
                                            {{ thread.user.name }}
                                            <small class="text-muted">{{ listRoles(thread.user) }}</small>
                                        </h4>
                                    </div>
                                    <div class="col-auto ml-auto">
                                        <h5 class="text-muted mb-0">
                                            Dibuat Tanggal: {{ [thread.createdAt, "YYYY-MM-DD HH:mm:ss"] | moment("D MMMM YYYY - HH:mm") }}
                                        </h5>
                                    </div>
                                    <div class="col-auto" v-if="roleElligibleThreadModified()">
                                        <ul class="navbar-nav dropdown-right ml-auto">
                                            <b-nav-item-dropdown right no-caret>
                                                <template slot="button-content">
                                                    <i class="fa fa-ellipsis-v"></i>
                                                </template>
                                                <b-dropdown-item v-bind:to="{ name: 'forum/thread/edit', params: {id: thread.id} }">
                                                    Edit Thread
                                                </b-dropdown-item>
                                                <b-dropdown-item v-on:click="modal.removeThread = true">
                                                    Hapus Thread
                                                </b-dropdown-item>
                                            </b-nav-item-dropdown>
                                        </ul>
                                    </div>
                                    <hr class="w-100" />
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <h3 class="font-weight-bold mb-0">
                                            <label v-if="thread.isSolved" class="badge badge-success text-dark badge-pill mb-1 align-middle">Solved</label>
                                            {{ thread.title }}
                                        </h3>
                                    </div>
                                    <hr class="w-100" />
                                </div>
                                <div class="row">
                                    <div class="col" v-html="thread.content"></div>
                                    <hr class="w-100" />
                                </div>
                                <div class="row">
                                    <div class="col-auto" v-if="thread.updatedAt">
                                        <h5 class="text-muted mb-0">
                                            Diedit Tanggal: {{ [thread.updatedAt, "YYYY-MM-DD HH:mm:ss"] | moment("D MMMM YYYY - HH:mm") }}
                                        </h5>
                                    </div>
                                    <div class="col-auto ml-auto" v-if="roleElligibleReply()">
                                        <a href="#reply" v-on:click="quoteComment = {}" class="btn btn-outline-danger btn-sm px-4">
                                            Balas
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="thread.solvingComment">
                    <div class="col">
                        <div class="card shadow-sm mb-3" v-bind:class="{'border-success': thread.solvingComment.isSolving, ' border-0': !thread.solvingComment.isSolving}">
                            <div class="card-body">
                                <div class="row align-items-center">
                                    <div class="col-auto" v-if="thread.solvingComment.user">
                                        <h4 class="font-weight-medium mb-0">
                                            {{ thread.solvingComment.user.name }}
                                            <small class="text-muted">{{ listRoles(thread.solvingComment.user) }}</small>
                                        </h4>
                                    </div>
                                    <div class="col-auto ml-auto">
                                        <h5 class="text-muted mb-0">
                                            Dibuat Tanggal: {{ [thread.solvingComment.createdAt, "YYYY-MM-DD HH:mm:ss"] | moment("D MMMM YYYY - HH:mm") }}
                                        </h5>
                                    </div>
                                    <div class="col-auto" v-if="roleElligibleCommentModified(thread.solvingComment) || roleElligibleSolve()">
                                        <ul class="navbar-nav dropdown-right ml-auto">
                                            <b-nav-item-dropdown right no-caret>
                                                <template slot="button-content">
                                                    <i class="fa fa-ellipsis-v"></i>
                                                </template>
                                                <template v-if="roleElligibleCommentModified(thread.solvingComment)">
                                                    <b-dropdown-item v-bind:to="{ name: 'forum/comment/edit', params: {id: thread.solvingComment.id} }">
                                                        Edit Post
                                                    </b-dropdown-item>
                                                    <b-dropdown-item v-on:click="removeCommentConfirm(thread.solvingComment)">
                                                        Hapus Post
                                                    </b-dropdown-item>
                                                </template>
                                                <b-dropdown-item v-on:click="solveCommentConfirm(thread.solvingComment)" v-if="roleElligibleSolve()">
                                                    {{ thread.solvingComment.isSolving ? 'Hapus' : 'Tandai' }} Sebagai Solusi
                                                </b-dropdown-item>
                                            </b-nav-item-dropdown>
                                        </ul>
                                    </div>
                                    <hr class="w-100" />
                                </div>
                                <div class="row">
                                    <div class="col" v-html="thread.solvingComment.content"></div>
                                    <hr class="w-100" />
                                </div>
                                <div class="row">
                                    <div class="col-auto" v-if="thread.solvingComment.updatedAt">
                                        <h5 class="text-muted mb-0">
                                            Diedit Tanggal: {{ [thread.solvingComment.updatedAt, "YYYY-MM-DD HH:mm:ss"] | moment("D MMMM YYYY - HH:mm") }}
                                        </h5>
                                    </div>
                                    <div class="col-auto ml-auto" v-if="roleElligibleReply()">
                                        <a href="#reply" v-on:click="quoteComment = thread.solvingComment" class="btn btn-outline-danger btn-sm px-4" v-bind:class="{active: quoteComment.id === thread.solvingComment.id}">
                                            Balas
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="pageCount">
                    <div class="col">
                        <div class="card shadow-sm mb-3 border-0">
                            <div class="card-body py-2">
                                <div class="row justify-content-end">
                                    <div class="col align-self-center">
                                        Halaman {{ page }} dari {{ pageCount }}
                                    </div>
                                    <div class="col-auto ml-auto">
                                        <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap mb-0" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                                        </paginate>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="primary-container">
                    <div class="col">
                        <template v-for="comment in comments">
                            <comment-item-view v-bind:comment="comment" v-bind:quoteComment="quoteComment" v-bind:listRoles="listRoles" v-bind:roleElligibleReply="roleElligibleReply" v-bind:roleElligibleModified="roleElligibleCommentModified" v-bind:roleElligibleSolve="roleElligibleSolve()" v-on:remove="removeCommentConfirm" v-on:solve="solveCommentConfirm" v-on:quote="comment => quoteComment = comment"></comment-item-view>
                        </template>
                    </div>
                </div>
                <div class="row" v-if="pageCount">
                    <div class="col">
                        <div class="card shadow-sm mb-3 border-0">
                            <div class="card-body py-2">
                                <div class="row justify-content-end">
                                    <div class="col align-self-center">
                                        Halaman {{ page }} dari {{ pageCount }}
                                    </div>
                                    <div class="col-auto ml-auto">
                                        <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap mb-0" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                                        </paginate>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="roleElligibleReply()">
                    <div class="col-12" v-if="Object.keys(quoteComment).length">
                        <h4 class="font-weight-medium">Quote Comment</h4>
                        <button type="button" v-b-tooltip.hover v-on:click="quoteComment = {}" class="position-absolute btn btn-link btn-sm" style="right: .8rem; top: 1.6rem;" title="Cancel Quote">
                            <i class="fa fa-times"></i>
                        </button>
                        <blockquote class="blockquote rounded bg-white">
                            <div v-html="quoteComment.content"></div>
                            <footer class="blockquote-footer font-weight-medium d-inline-block h4 text-dark">
                                {{ quoteComment.user.name }}
                                <small class="text-muted">{{ listRoles(quoteComment.user) }}</small>
                            </footer>
                        </blockquote>
                    </div>
                    <div class="col-12">
                        <form v-on:submit.prevent="save">
                            <div id="reply" class="card shadow-sm mb-3 border-0">
                                <div class="card-body">
                                    <h3 class="font-weight-bold">
                                        Balas
                                    </h3>
                                    <tinymce id="editor" v-model="form.content" v-bind:other_options="tinyMCEOptions"></tinymce>
                                    <div class="row mt-3">
                                        <div class="col-auto ml-auto">
                                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                                Post
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <b-modal v-model="modal.removeThread" modal-class="border-0" header-class="background-primary" footer-class="justify-content-center" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin ingin menghapus thread ini? Lanjutkan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="remove">
                            Hapus
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.removeThread = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal v-if="reference" v-model="modal.removeComment" modal-class="border-0" header-class="background-primary" footer-class="justify-content-center" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin ingin menghapus komentar ini? Lanjutkan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="removeComment">
                            Hapus
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.removeComment = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal v-if="reference" v-model="modal.solveComment" modal-class="border-0" header-class="background-primary" footer-class="justify-content-center" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin ingin {{ reference.isSolving ? 'menghapus' : 'memberi' }} tanda komentar ini sebagai penyelesaian? Lanjutkan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="solveComment">
                            Tandai
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.solveComment = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import Paginate from 'vuejs-paginate';
    import tinymce from 'vue-tinymce-editor';
    import CommentItem from "@/components/forum/thread/item/Comment";
    import { tinyMCEOptions, employeeRoles, additionalRoles } from '@/params.js';
    import { mapState } from 'vuex';

    export default {
        name: "ForumThreadView",
        computed: mapState([
            'profile'
        ]),
        components: {
            Paginate,
            tinymce,
            "comment-item-view": CommentItem
        },
        data() {
            return {
                thread: {user: {}, forumSubcategory: {gradeSubject: {grade: {}, subject: {}}}},
                comments: [],
                form: {content: ''},
                roles: [],
                quoteComment: {},
                reference: null,
                page: 1,
                pageCount: 20,
                modal: {removeThread: false, removeComment: false, solveComment: false},
                tinyMCEOptions: tinyMCEOptions
            };
        },
        methods: {
            save() {
                this.axios.post(process.env.API_URL + '/thread/' + this.thread.id + '/reply', Object.assign({}, this.form, {quotedID: this.quoteComment.id})).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        for (let i in this.form) {
                            this.form[i] = '';
                        }
                        this.quoteComment = {};
                        this.paginate(this.page);
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            paginate(page, scroll = true) {
                this.axios.get(process.env.API_URL + '/comment', {params: {threadID: this.$route.params.id, page: page}}).then(response => {
                    this.comments = response.data.data.data;
                    this.pageCount = response.data.data.total ? response.data.data.last_page : 0;

                    if (scroll) {
                        document.getElementById('primary-container').scrollIntoView();
                        var headerElement = document.getElementsByTagName('nav');
                        if (headerElement.length) {
                            window.scrollBy(0, headerElement[0].offsetHeight * -1);
                        }
                    }
                });
            },
            fetchData() {
                this.axios.get(process.env.API_URL + '/thread/' + this.$route.params.id).then(response => {
                    this.thread = response.data.data;

                    this.paginate(this.page, false);

                    document.title = 'Forum - ' + this.thread.title + ' | ' + process.env.APP_NAME;
                });
            },
            remove() {
                this.axios.post(process.env.API_URL + '/thread/delete/' + this.thread.id).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'forum/thread/index', params: {id: this.thread.forumSubcategoryID}});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            removeComment() {
                if (this.reference) {
                    this.axios.post(process.env.API_URL + '/comment/delete/' + this.reference.id).then(response => {
                        if (response.data.status) {
                            this.fetchData();
                            this.modal.removeComment = false;
                            this.$toastr('success', response.data.message, 'Success');
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                    });
                }
            },
            solveComment() {
                if (this.reference) {
                    this.axios.post(process.env.API_URL + '/comment/toggle-solving/' + this.reference.id).then(response => {
                        if (response.data.status) {
                            this.fetchData();
                            this.modal.solveComment = false;
                            this.$toastr('success', response.data.message, 'Success');
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                    });
                }
            },
            removeCommentConfirm(comment) {
                this.modal.removeComment = true;
                this.reference = comment;
            },
            solveCommentConfirm(comment) {
                this.modal.solveComment = true;
                this.reference = comment;
            },
            listRelations(relations) {
                return typeof relations !== typeof undefined ? relations.map(object => object.name).join(', ') : '';
            },
            listRoles(user) {
                var roles = [];
                for (var i in additionalRoles) {
                    if (user['is' + additionalRoles[i].id]) {
                        roles.push(additionalRoles[i].id);
                    }
                }
                if (user.isEmployee) {
                    for (var i in employeeRoles) {
                        if (user.employee['is' + employeeRoles[i].id]) {
                            roles.push(employeeRoles[i].id);
                        }
                    }
                }
                return this.listRelations(this.roles.filter(object => roles.includes(object.id)));
            },
            roleElligibleThreadModified() {
                return this.profile.isAdmin || (this.thread.userID === this.profile.id && this.$moment().utcOffset(0).isBefore(this.$moment(this.thread.createdAt, 'YYYY-MM-DD HH:mm:ss').utcOffset(0).add(process.env.FORUM_CHANGE_MINUTES, 'minutes')));
            },
            roleElligibleCommentModified(comment) {
                return this.profile.isAdmin || (comment.userID === this.profile.id && this.$moment().utcOffset(0).isBefore(this.$moment(comment.createdAt, 'YYYY-MM-DD HH:mm:ss').utcOffset(0).add(process.env.FORUM_CHANGE_MINUTES, 'minutes')));
            },
            roleElligibleReply() {
                let elligible = this.profile.isAdmin || this.profile.isStudent;
                if (!elligible && this.profile.isEmployee) {
                    let roleElligible = this.profile.employee.isDirector || this.profile.employee.isManager || this.profile.employee.isBranchStaff || this.profile.employee.isMentor || this.profile.employee.isBranchHead;
                    let teacherElligible = this.profile.employee.isTeacher && this.profile.employee.teacher.subjects.map(subject => subject.id).includes(this.thread.forumSubcategory.gradeSubject.subjectID);
                    let coordinatorElligible = this.profile.employee.isCoordinator && this.profile.employee.coordinator.subjectID === this.thread.forumSubcategory.gradeSubject.subjectID;
                    elligible = roleElligible || teacherElligible || coordinatorElligible;
                }
                return elligible;
            },
            roleElligibleSolve() {
                let elligible = this.profile.isAdmin;
                if (!elligible && this.profile.isEmployee) {
                    let roleElligible = this.profile.employee.isDirector || this.profile.employee.isManager;
                    let coordinatorElligible = this.profile.employee.isCoordinator && this.profile.employee.coordinator.subjectID === this.thread.forumSubcategory.gradeSubject.subjectID;
                    elligible = roleElligible || coordinatorElligible;
                }
                return elligible;
            }
        },
        created() {
            this.roles = employeeRoles.concat(additionalRoles);
            this.fetchData();
        }
    };
</script>

<style scoped>
    .navbar-nav >>> .nav-link { padding: 0rem 1rem; }
</style>


// WEBPACK FOOTER //
// src/components/forum/thread/View.vue